<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <SearchInput :search-change="searchChange" />
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :update-filter="updateFilter"
          :loading-instance="loadingInstance"
          :set-loading-instance="setLoadingInstance"
          :selected-list="selectedList"
          :set-selected-list="setSelectedList"
          class="overflow-auto pr-1"
          table-name="permissionsUsersTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { UserMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import { ROLES_NAMES } from '../../../../../../../constants';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import PermissionsUserIcon from '../../../../assets/icons/iconsCode/permissions-users.vue';

let inputInterval = null;

export default {
  name: 'PermissionsUsers',
  components: { Table, SearchInput },
  mixins: [UserMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    return {
      selectedUser: {},
      selectedList: [],
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 30,
        totalCount: 0,
        sortBy: 'filterUsername',
        sortOrder: 'asc',
        searchQuery: '',
      },
      columns: [
        {
          field: 'filterUsername',
          title: this.$translate('name'),
          key: '2',
          sortBy: 'asc',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.username;
          },
        },
        {
          field: 'email',
          title: this.$translate('email'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'role',
          title: this.$translate('user_role'),
          key: '4',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(ROLES_NAMES[row.role]);
          },
        },
        {
          field: 'createdAt',
          title: this.$translate('created_date'),
          key: '6',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          width: 55,
          renderBodyCell: ({ row }, h) => (
            h(
              'b-button',
              {
                props: {
                  variant: 'primary',
                  size: 'sm',
                },
                class: 'px-2',
                on: {
                  click: () => this.goToDetails(row.id),
                },
              },
              [h(PermissionsUserIcon)]
            )
          ),
        },
      ],
      rows: [],
    };
  },
  methods: {
    goToDetails(id) {
      this.$router.push({ name: 'view-permissions-details', params: { userId: id } });
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        const response = await this.userService.getUsersPage(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data.map((item) => ({
          ...item,
          attributesRow: item.attributes.join(', '),
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
        }));
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 17px;
  margin: auto;
  cursor: pointer;
  margin-left: 5px;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

::v-deep .action-block {
  display: flex;
  justify-content: center;
}

::v-deep .action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.action-buttons-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-buttons-wrapper button {
  white-space: nowrap;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
